import type { CSSProperties, MouseEvent, ReactNode } from "react";
import { useNavModel } from "../nav/areas";
import { isPlainLeftClick } from "../nav/LinkAdapter";

/**
 * A link to a page inside the current shell. Goes through the shell's adapter so the same
 * path works in the client app, the consultant read-through and the Jersey edition; a
 * modified click still opens a real URL in a new tab.
 */
export function ShellLink({ to, children, style, title }: { to: string; children: ReactNode; style?: CSSProperties; title?: string }) {
  const { adapter } = useNavModel();
  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (!adapter || !isPlainLeftClick(e)) return;
    e.preventDefault();
    adapter.navigate(to);
  };
  return (
    <a href={adapter ? adapter.href(to) : to} onClick={onClick} style={style} title={title}>
      {children}
    </a>
  );
}
